import React, { useState } from "react";
import * as styles from "../styles/components/faq.module.css";
import Container from "./container";
import Icon from "./icon";
import PortableText from "./portableText";
import SectionHeader from "./product-section-header";
import { cn } from "../lib/helpers";
import { Link } from "gatsby";

const Faq = (props) => {
  // Dummy FAQ data matching your structure

  const { title, faqs, bottomTitle, _rawBottomText,bottomCta } = props;
  
  return (
    <div className={styles.root} id="faq">
      <Container>
        {title && <h2 className={styles.title}>{title}</h2>}
        <div className={styles.faqContainer}>
          {faqs.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq._rawAnswer}
            />
          ))}
        </div>
        <div className={styles.center}>
        {bottomTitle && (
          <SectionHeader noBottomMargin title={bottomTitle} description={_rawBottomText} />
        )}
        {bottomCta && bottomCta && bottomCta.url && (
          <>
            {bottomCta.blank ? (
              <a
                href={bottomCta.url}
                className={cn(
                  "btn",
                  bottomCta.secondaryButton
                    ? "secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke"
                    : "color-palette-pseudo-bg"
                )}
                target="_blank"
                rel="noreferrer"
              >
                {bottomCta.text}
                <Icon symbol="arrow-right" />
              </a>
            ) : (
              <Link
                to={bottomCta.url}
                className={cn(
                  "btn",
                  bottomCta.secondaryButton
                    ? "secondary color-palette-color color-palette-pseudo-bg-dark color-palette-svg-stroke"
                    : "color-palette-pseudo-bg"
                )}
              >
                {bottomCta.text}
                <Icon symbol="arrow-right" />
              </Link>
            )}
          </>
        )}
        </div>
      
      </Container>
    </div>
  );
};

const FaqItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.faq}>
      <button className={styles.questionWrapper} onClick={toggleOpen}>
        <h3 className={styles.question}>{question}</h3>
        <div className={`${styles.icon} ${isOpen ? styles.iconRotated : ""}`}>
          <Icon symbol="chevron-down" />
        </div>
      </button>
      {isOpen && (
        <div className={styles.answer}>
          <PortableText blocks={answer} />
        </div>
      )}
    </div>
  );
};

export default Faq;
